var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Moon, Sun } from 'lucide-react';
import { ThemeContext } from '../../context/ThemeContext';
import { Button } from './Button';
import { cn } from '../../lib/utils';
var ThemeToggle = function (_a) {
    var className = _a.className, _b = _a.size, size = _b === void 0 ? 'default' : _b;
    var _c = useContext(ThemeContext), theme = _c.theme, toggleTheme = _c.toggleTheme;
    return (_jsxs(Button, __assign({ variant: "outline", size: size === 'sm' ? 'sm' : size === 'lg' ? 'lg' : 'icon', onClick: toggleTheme, className: cn("relative overflow-hidden transition-all duration-300", className), "aria-label": "Switch to ".concat(theme === 'light' ? 'dark' : 'light', " mode") }, { children: [_jsx(Sun, { className: cn("h-4 w-4 rotate-0 scale-100 transition-all duration-300", theme === 'dark' && "-rotate-90 scale-0") }), _jsx(Moon, { className: cn("absolute h-4 w-4 rotate-90 scale-0 transition-all duration-300", theme === 'dark' && "rotate-0 scale-100") }), _jsx("span", __assign({ className: "sr-only" }, { children: "Toggle theme" }))] })));
};
export default ThemeToggle;
